export default __webpack_public_path__ + "static/logo_myway~biRDdwcU-a29484308b04bd65e48096e8f076cea7.png";